// components/ImageGrid/ImageGrid.js

import React, { useState, useEffect, useRef } from "react";
import { VirtuosoGrid } from "react-virtuoso";
import "./ImageGrid.css";
//import "./ImageCell.css";
import ImageCell from "./ImageCell/ImageCell";
import GridPlaceholderCell from "./GridPlaceholderCell";
//import { useGridMetrics } from "./../../hooks/useGridMetrics";

const GAP = 4;
//
// 1) --- ListContainer avec ref pour observer la grille ---
//
const ListContainer = React.forwardRef(({ style, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      {...props}
      style={{
        ...style,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: "4px",
        alignContent: "start",
      }}
      className="grid-virtuoso-container"
    >
      {children}
    </div>
  );
});

const ItemContainer = ({ children, ...props }) => (
  <div
    {...props}
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
    }}
  >
    {children}
  </div>
);

//
// --------------------
// 2) IMAGE GRID LOGIQUE
// --------------------
//
const ImageGrid = ({ images, onOpenStreetView, onOpenFullImage, gridRef }) => {
  const wrapperRef = useRef(null);
  const listRef = useRef(null);
  const [columns, setColumns] = useState(1);
  const [visibleRows, setVisibleRows] = useState(1);

  //
  // 3) --- Observer le nombre de colonnes réelles ---
  //
  useEffect(() => {
    if (!wrapperRef.current) return;

    const observer = new ResizeObserver((entries) => {
      // attendre que le layout CSS ait mis à jour les colonnes
      requestAnimationFrame(() => {
        if (!listRef.current) return;
        const width = entries[0].contentRect.width;
        const style = getComputedStyle(listRef.current);
        const cols = style.gridTemplateColumns.split(" ").length;
        const cellSize = width / cols - GAP * (cols + 1);

        ///const visibleRows = Math.floor(window.innerHeight / cellSize);
        setColumns(cols || 1);
        setVisibleRows(Math.floor(window.innerHeight / cellSize) || 1);
        //console.log("visibleRows", Math.floor(window.innerHeight / cellSize));
      });
    });
    
    observer.observe(wrapperRef.current);

    return () => observer.disconnect();
  }, []);

  //
  // 4) --- Calcul des cases fantômes ---
  //
  const itemCount = images?.length ?? 0;

  const lastLineEmptySlots =
    columns > 0 ? (columns - (itemCount % columns)) % columns : 0;

  const emptySlots = Math.max(
    0,
    Math.ceil(visibleRows * columns - (itemCount + lastLineEmptySlots))
  );
  //const { minItems } = useGridMetrics(200, 4, columns);

  /*console.log(
    "lastLineEmptySlots",
    lastLineEmptySlots,
    "itemCount",
    itemCount,
    "columns",
    columns,
    "visibleRows",
    visibleRows,
    "emptySlots",
    emptySlots
  );
  */
  //
  // 5) --- Construire tableau avec placeholders ---
  //
  const imagesWithPlaceholders = [
    ...images,
    ...Array.from({ length: lastLineEmptySlots + emptySlots }).map(() => ({
      isPlaceholder: true,
      id: `phantom-${Math.random()}`,
    })),
  ];

  //
  // 6) --- Cas : liste vide ---
  /*
  if (!images || images.length === 0) {
    console.log('coucou',lastLineEmptySlots + emptySlots);
    return (
      <div className="grid-empty-state">
        {Array.from({ length: lastLineEmptySlots + emptySlots }).map((_, i) => (
          <GridPlaceholderCell key={i} />
        ))}
      </div>
    );
  }
  */

  return (
    <div className="grid-wrapper" ref={wrapperRef}>
      <VirtuosoGrid
        ref={gridRef}
        totalCount={imagesWithPlaceholders.length}
        overscan={800}//{window.innerHeight}
        style={{ height: "100%", width: "100%" }}
        components={{
          List: React.forwardRef((props, ref) => (
            <ListContainer
              {...props}
              ref={(node) => {
                listRef.current = node;
                if (typeof ref === "function") ref(node);
                else if (ref) ref.current = node;
              }}
            />
          )),
          Item: ItemContainer,
        }}
        itemContent={(index) => {
          const img = imagesWithPlaceholders[index];

          if (img.isPlaceholder) {
            return <GridPlaceholderCell />;
          }

          return (
            <ImageCell
              img={img}
              index={index}
              onOpenStreetView={onOpenStreetView}
              onOpenFull={onOpenFullImage}
            />
          );
        }}
      />
    </div>
  );
};

/*
const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.images === nextProps.images &&
    prevProps.onOpenStreetView === nextProps.onOpenStreetView &&
    prevProps.onOpenFullImage === nextProps.onOpenFullImage &&
    prevProps.gridRef === nextProps.gridRef
  );
};

export default React.memo(ImageGrid, areEqual);*/

export default React.memo(ImageGrid);
